import _styled from '@emotion/styled/base';
import { Radio, FormControlLabel } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledRadioButton = /*#__PURE__*/_styled(Radio, {
  shouldForwardProp: isStyledPropsValid,
  target: "e10oiihc3"
})(_ref => {
  return {
    padding: '6px 8px 6px 6px'
  };
}, "");
const StyledRadioIcon = /*#__PURE__*/_styled('span', {
  shouldForwardProp: isStyledPropsValid,
  target: "e10oiihc2"
})(_ref2 => {
  let {
    theme
  } = _ref2;
  return {
    borderRadius: '50%',
    width: 18,
    height: 18,
    border: "2px solid ".concat(theme.customColors.purple[500]),
    backgroundColor: 'white',
    '.Mui-focusVisible &': {
      outline: '2px auto rgba(19,124,189,.6)',
      outlineOffset: 2
    },
    'input:disabled ~ &': {
      boxShadow: 'none',
      background: 'rgba(206,217,224,.5)',
      border: "2px solid ".concat(theme.customColors.grey[500])
    }
  };
}, "");
const getSVG = color => "url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\"><path d=\"M12.5655 4.24464L6.21755 12.2292L3 8.18214L4.56553 6.9375L6.21755 9.01543L11 3L12.5655 4.24464Z\" fill=\"".concat(encodeURIComponent(color), "\"/></svg>')");
const StyledRadioCheckedIcon = /*#__PURE__*/_styled(StyledRadioIcon, {
  shouldForwardProp: isStyledPropsValid,
  target: "e10oiihc1"
})(_ref3 => {
  let {
    theme
  } = _ref3;
  return {
    backgroundColor: theme.customColors.purple[500],
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      transform: ' translateX(-0.5px)',
      backgroundImage: getSVG(theme.customColors.white),
      content: '""'
    }
  };
}, "");
const StyledFormControlLabel = /*#__PURE__*/_styled(FormControlLabel, {
  shouldForwardProp: isStyledPropsValid,
  target: "e10oiihc0"
})(_ref4 => {
  return {
    marginRight: 0,
    marginLeft: 0,
    alignItems: 'center',
    '& .MuiTypography-root': {
      lineHeight: 1.25
    }
  };
}, "");
export { StyledFormControlLabel, StyledRadioButton, StyledRadioCheckedIcon, StyledRadioIcon };